import {
  Trees,
  Mountain,
  Truck,
  Hammer,
  Layers,
  Wrench,
  Sprout,
  ArrowUpRight,
} from "lucide-react";
import { FadeUp } from "./Reveal";

const ITEMS = [
  {
    n: "01",
    id: "landscaping",
    title: "Landscaping",
    desc: "Mulch beds, sod install, plant selection, hardscape prep — we design and build yards that make neighbors stop and stare.",
    Icon: Sprout,
  },
  {
    n: "02",
    id: "lawn-care",
    title: "Lawn Care",
    desc: "Mowing, edging, trimming, seasonal cleanups. We keep your yard sharp year-round.",
    Icon: Trees,
  },
  {
    n: "03",
    id: "lot-clearing",
    title: "Lot Clearing",
    desc: "Brush, trees, stumps & overgrowth cleared. We prep your land for whatever's next.",
    Icon: Trees,
  },
  {
    n: "04",
    id: "gravel-driveways",
    title: "Gravel Driveways",
    desc: "Fresh gravel driveways and road repair — graded, leveled, built to last through the rains.",
    Icon: Mountain,
  },
  {
    n: "05",
    id: "haul-offs",
    title: "Junk Removal & Haul Offs",
    desc: "Dirt, debris, junk, appliances — hauled away so you don't have to look at it again.",
    Icon: Truck,
  },
  {
    n: "06",
    id: "grading",
    title: "Grading & Leveling",
    desc: "Yard grading, drainage, pad prep. We get the slope right the first time.",
    Icon: Layers,
  },
  {
    n: "07",
    id: "demos",
    title: "Demolition",
    desc: "Sheds, fences, slabs, small structures — torn down and hauled out clean.",
    Icon: Hammer,
  },
  {
    n: "08",
    id: "bobcat",
    title: "Bobcat Services",
    desc: "Skid-steer work for tight spots — digging, moving dirt, post holes, you name it.",
    Icon: Wrench,
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-28 md:py-40 bg-[#FFFFFF] text-[#111613]"
    >
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <FadeUp>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-24 items-end">
            <div className="md:col-span-8">
              <div className="chapter-line text-[#0E2A1A] mb-6">
                Ch. 01 · What We Do
              </div>
              <h2
                className="font-display text-[#0E2A1A] text-6xl sm:text-7xl md:text-8xl lg:text-[7.5rem] leading-[0.92] tracking-[-0.03em]"
                style={{ fontWeight: 400 }}
              >
                Full-service{" "}
                <span className="italic text-[#DA7B3C]">dirt work</span>
                <br />
                for every yard.
              </h2>
            </div>
            <p className="md:col-span-4 text-lg text-[#111613]/70 leading-relaxed max-w-sm">
              From a single haul-off to a full landscape overhaul — we show up
              with the crew, the truck, and the bobcat.
            </p>
          </div>
        </FadeUp>

        <div className="border-t border-[#111613]/15">
          {ITEMS.map(({ n, id, title, desc, Icon }, idx) => (
            <FadeUp key={id} delay={idx * 0.04}>
              <a
                href="#quote"
                data-testid={`service-card-${id}`}
                className="group grid grid-cols-12 gap-4 md:gap-8 items-center py-7 md:py-10 border-b border-[#111613]/15 transition-all hover:bg-[#0E2A1A] hover:text-[#FFFFFF] px-3 -mx-3"
              >
                <div className="col-span-2 md:col-span-1">
                  <div className="font-mono-sm text-[#DA7B3C]">{n}</div>
                </div>
                <div className="col-span-8 md:col-span-5 flex items-center gap-5">
                  <Icon
                    className="w-5 h-5 md:w-6 md:h-6 text-current opacity-60 group-hover:opacity-100 shrink-0"
                    strokeWidth={1.5}
                  />
                  <h3
                    className="font-display text-3xl md:text-5xl lg:text-6xl leading-none tracking-[-0.025em]"
                    style={{ fontWeight: 400 }}
                  >
                    {title}
                  </h3>
                </div>
                <div className="hidden md:block md:col-span-5">
                  <p className="text-base md:text-lg text-current/70 leading-snug max-w-lg">
                    {desc}
                  </p>
                </div>
                <div className="col-span-2 md:col-span-1 flex justify-end">
                  <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center border border-current/30 group-hover:border-[#DA7B3C] group-hover:bg-[#DA7B3C] group-hover:text-[#FFFFFF] transition-all rounded-full">
                    <ArrowUpRight
                      className="w-4 h-4 md:w-5 md:h-5 group-hover:rotate-12 transition-transform"
                      strokeWidth={1.75}
                    />
                  </span>
                </div>
                <div className="md:hidden col-span-12 pl-7">
                  <p className="text-sm text-current/70 leading-snug">{desc}</p>
                </div>
              </a>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
